module.exports = __webpack_public_path__ + "img/宰相回宫 v4.8f22b2f0.png";